export default {
    listagem: {
        titulo_pagina: 'Manufacturers List',
        novo: 'Add New Manufacturer',
        table: {
            empty: 'No Manufacturer Found',
            nome: 'Name',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Manufacturer',
            editar: 'Edit Manufacturer'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Manufacturer Name'
            },
            status: {
                label: 'Status',
                description: 'Manufacturer active or inactive status'
            },
            botao_salvar : 'Save Manufacturer'
        },
        create: {
            success: 'Manufacturer successfully created!',
            error: 'Error creating manufacturer!'
        },
        update: {
            success: 'Manufacturer successfully edited!',
            error: 'Error editing manufacturer!'
        }
    }
}
